import React from 'react'
import PropTypes from 'prop-types'
import {observer} from 'mobx-react'
import ReviewSelectAsyncInput from '~/components/forms/review_form/review_select_async_input'
import ReactSelectAsyncInputStore from '@hikakaku/shared/stores/estimate_form/common/input/react_select_async_input_store'

@observer
export default class ReviewFormInnerMapInput extends React.Component {
  static propTypes = {
    reviewFormStore: PropTypes.object
  }

  constructor(props) {
    super(props)
    this.mapStore = new ReactSelectAsyncInputStore({
      name: 'reviewer_map',
      value: props.reviewFormStore.userInputMapName,
      optionDataSource: {
        url: '/api/elasticsearch/categories/search_raw?type=maps',
        query: {}
      },
      // DB（categories: code=maps）に存在する地域のみ選択可能にする
      strictSelection: true,
      disabled: false,
      necessary: true
    })
  }

  render() {
    return (
      <div className="reviewpopup-Form_content">
        <div className="reviewpopup-Form_title">
          <label htmlFor="reviewer_map">地域</label>
          <span className="required">※必須</span>
          <span className="co-gray-2">（お住まいの地域）</span>
        </div>
        <div>
          <ReviewSelectAsyncInput
            store={this.mapStore}
            inputId="reviewer_map"
            placeholder="例:新宿区"
            onSelected={(val) => { this.props.reviewFormStore.userInputMapName = val }}
          />
        </div>
      </div>
    )
  }
}
